import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigTrelloMcpSettings } from "./app-settings-config-trello";

export interface IConfigTrelloMcpInputState {
  showModal: boolean;
  editingTrelloMcpId: string;
}

export interface IConfigTrelloMcpInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigTrelloMcpInput extends PureComponent<IConfigTrelloMcpInputProps, IConfigTrelloMcpInputState> {
  formInputName: string[] = ["apiConfig", "trelloMcpSettingsId"];

  constructor(props: IConfigTrelloMcpInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingTrelloMcpId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingTrelloMcpId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string): void => {
    this.setState({ editingTrelloMcpId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render(): ReactNode {
    return (
      <>
        <ConfigTrelloMcpSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingTrelloMcpId={this.state.editingTrelloMcpId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Trello"
          formInputName={this.formInputName}
          options={this.props.commonSettings.trelloMcpSettings ?? []}
          allowClear
          tooltipContentKey="appsettings_mcp_trellomcp"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsMcpTrelloDropdown"
          addNewTestId="appSettingsMcpTrelloAddNewButton"
          editTestId="appSettingsMcpTrelloEditButton"
        />
      </>
    );
  }
}
